export const PURCHASED_AT_FORMAT = 'MM/DD/YY';
export const TIME_DUE_FORMAT = 'LT';
export const DUE_DATE_FORMAT = 'dddd MM/DD/YY';
